import { useState } from 'react';
import { Container, Row, Col, Button, ListGroup, Form } from 'react-bootstrap';
import { toast } from "react-toastify";
import {
    Phone,
    Mail,
    MapPin,
    Clock,
    Facebook,
    Twitter,
    Linkedin,
    Instagram,
    Award,
    Briefcase,
    ArrowUp,
    ChevronRight,
    Send
} from 'react-feather';
import { Link } from 'react-router-dom';

const Footer = () => {

    const practiceAreas = [
        { name: "Dispute Resolution & Litigation", path: "/DisputeResolution" },
        { name: "Arbitration, Mediation & Conciliation", path: "/ArbitrationMediation" },
        { name: "Real Estate & Property law", path: "/RealEstateLaw" },
        { name: "Corporate & Commercial law", path: "/CorporateCommercialLaw" },
        { name: "Banking & Securitization", path: "/BankingSecuritization" },
        { name: "Taxation (Direct & Indirect)", path: "/TaxationLaw" },
        { name: "Intellectual Property", path: "/IntellectualPropertyLaw" }
    ];

    const quickLinks = [
        { name: 'Our Team', path: '/about-us' },
        { name: 'Contact Us', path: '/contact' },
        { name: 'Our Story', path: '/ourstory' },
        { name: 'Why Choose Us', path: '/whychooseus' },
        // { name: 'Testimonials', path: '/testimonials' },
        // { name: 'Blog', path: '/BlogPage' },
    ];
    const contactInfo = [
        {
            icon: <MapPin size={18} />,
            text: 'Unit No. 8, 2nd Floor, Orchid Mall, Boring Road,',
            detail: 'Patna - 800013, Bihar, India',
        },
        {
            icon: <Phone size={18} />,
            text: (
                <>
                    <a className="contact-link" href="tel:+919473425998">+91 94734 25998</a>,{' '}
                    <a className="contact-link" href="tel:+917903415161">+91 79034 15161</a>

                </>
            ),
            detail: '',
        },
        {
            icon: <Mail size={18} />,
            text: (
                <a className="contact-link" href="mailto:rnalawchambers@gmail.com">
                    rnalawchambers@gmail.com
                </a>
            ),
            detail: 'General Inquiries',
        },
        {
            icon: <Clock size={18} />,
            text: 'Mon–Thur: 5 P.M.–8 P.M.',
            detail: 'Sunday: 10 A.M.–2 P.M.',
        },
    ];


    const socialLinks = [
        { icon: <Facebook size={20} />, url: '#' },
        { icon: <Twitter size={20} />, url: '#' },
        { icon: <Linkedin size={20} />, url: 'https://www.linkedin.com/in/nkagrawal?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app' },
        { icon: <Instagram size={20} />, url: '#' },
    ];

    const awards = [
        { name: 'Forbes Legal 2024' },
        { name: 'ABA Approved' },
        { name: 'BBB A+ Rating' },
        { name: 'Legal 500' },
    ];
    const [email, setEmail] = useState("");

    const handleSubmit = async () => {

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!email.trim()) {
         
            toast.error("Please enter your email");
            return;
        }

        if (!emailRegex.test(email)) {
            toast.error("Please enter a valid email address");
            return;
        }


        try {
            // Disable button or just run logic
            await fetch(
                "https://script.google.com/macros/s/AKfycbyr2t6pY7sDoWwHC2H5M6-wtXyVwi4RfP86zBFTfEPccB1sHIRcYbxgePxf-WfV1cvn6w/exec",
                {
                    method: "POST",
                    mode: "no-cors",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ email }),
                }
            );

            // Give a natural delay before showing success
            setTimeout(() => {
                toast.success("Email saved successfully!");
                setEmail(""); // Clear input AFTER toast
            }, 300);

        } catch (err) {
            console.log("Fetch error ignored:", err);

            // Show toast + clear even on error (no-cors hides response anyway)
            setTimeout(() => {
                toast.success("Email saved successfully!");
                setEmail("");
            }, 300);
        }
    };
    return (
        <footer style={{ backgroundColor: 'var(--primary-dark)', color: 'var(--text-primary)' }}>

            {/* Newsletter */}
            <div style={{ backgroundColor: 'var(--primary-blue)', padding: '2rem 0', marginBottom: '3rem', color: 'var(--cream)' }}>
                <Container>
                    <Row className="align-items-center">
                        <Col md={6} className="mb-3 mb-md-0">
                            <h5 className="fw-bold">Stay Updated With Us</h5>
                            <p className="mb-0" style={{ color: 'var(--gray-light)' }}>
                                Subscribe for legal insights, updates, and firm news.
                            </p>
                        </Col>
                        <Col md={6}>
                            <Form className="d-flex flex-column flex-sm-row gap-2">
                                <Form.Control
                                    type="email"
                                    placeholder="Your email address"
                                    className="rounded-pill"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    style={{
                                        backgroundColor: 'var(--primary-dark)',
                                        color: 'var(--cream)',
                                        border: '1px solid var(--gold-light)',
                                    }}
                                />
                                <Button
                                    type='button'
                                    style={{
                                        backgroundColor: 'var(--gold)',
                                        border: 'none',
                                        borderRadius: '50px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                    onClick={handleSubmit}
                                >
                                    <Send size={16} />
                                </Button>
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Main Footer */}
            <Container>
                <Row className="gx-5 gy-5">

                    {/* Brand */}
                    <Col lg={4} md={6} className="text-center text-lg-start">
                        <div className="d-flex align-items-center mb-3 justify-content-center justify-content-lg-start">
                            <img
                                src="logo.jpeg"
                                alt="RNA Law Chambers Logo"
                                className="me-2"
                                style={{ height: "40px", width: "auto" }}
                            />
                            <div>
                                <h3 className="fw-bold mb-0" style={{ color: 'var(--cream)' }}>
                                    RNA <span style={{ color: 'var(--gold)' }}>Law Chambers</span>
                                </h3>
                                <small style={{ color: 'var(--gray-light)' }}>Bringing moral spark to Legal Practice</small>
                            </div>
                        </div>
                        <p style={{ lineHeight: 1.8, color: 'var(--gray-light)' }}>
                            Trusted legal advisors with over 18 years of combined experience. Dedicated to protecting your rights with integrity and precision.
                        </p>

                        <div className="mb-3 d-none">
                            <h6 className="fw-bold mb-2" style={{ color: 'var(--gold)' }}>
                                <Award size={16} className="me-2" /> Awards & Recognition
                            </h6>
                            {awards.map((award, i) => (
                                <span
                                    key={i}
                                    style={{
                                        backgroundColor: 'var(--gold-light)',
                                        color: 'var(--primary-dark)',
                                        padding: '0.25rem 0.75rem',
                                        borderRadius: '50px',
                                        marginRight: '0.5rem',
                                        marginBottom: '0.5rem',
                                        display: 'inline-block'
                                    }}
                                >
                                    {award.name}
                                </span>
                            ))}
                        </div>

                        <div className="d-flex gap-3 justify-content-center justify-content-lg-start">
                            {socialLinks.map((s, i) => (
                                <a
                                    key={i}
                                    href={s.url}
                                    style={{ color: 'var(--gold)', fontSize: '1.25rem', transition: '0.3s' }}
                                >
                                    {s.icon}
                                </a>
                            ))}
                        </div>
                    </Col>

                    {/* Practice Areas */}
                    <Col lg={3} md={6}>
                        <h5 className="fw-bold mb-3" style={{ color: 'var(--cream)' }}>Practice Areas</h5>
                        <ListGroup variant="flush">
                            {practiceAreas.map((a, i) => (
                                <ListGroup.Item key={i} className="bg-transparent border-0 px-0 py-1">
                                    <Link
                                        to={a.path}
                                        className="text-decoration-none d-flex align-items-center"
                                        style={{ color: 'var(--gray-light)' }}
                                    >
                                        <ChevronRight size={16} className="me-2" /> {a.name}
                                    </Link>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    </Col>

                    {/* Quick Links */}
                    <Col lg={2} md={6}>
                        <h5 className="fw-bold mb-3" style={{ color: 'var(--cream)' }}>Quick Links</h5>
                        <ListGroup variant="flush">
                            {quickLinks.map((l, i) => (
                                <ListGroup.Item key={i} className="bg-transparent border-0 px-0 py-1">
                                    <Link
                                        to={l.path}
                                        className="text-decoration-none d-flex align-items-center"
                                        style={{ color: 'var(--gray-light)' }}
                                    >
                                        <ChevronRight size={16} className="me-2" /> {l.name}
                                    </Link>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    </Col>

                    {/* Contact */}
                    <Col lg={3} md={6}>
                        <h5 className="fw-bold mb-3" style={{ color: 'var(--cream)' }}>Contact Us</h5>
                        {contactInfo.map((info, i) => (
                            <div key={i} className="d-flex mb-3">
                                <div style={{ color: 'var(--gold)', marginRight: '0.75rem' }}>{info.icon}</div>
                                <div>
                                    <div className="fw-bold" style={{ color: 'var(--cream)' }}>{info.text}</div>
                                    <small style={{ color: 'var(--gray-light)' }}>{info.detail}</small>
                                </div>
                            </div>
                        ))}
                    </Col>
                </Row>
            </Container>

            {/* Footer Bottom */}
            <div style={{ borderTop: '1px solid var(--gray-medium)', padding: '1.5rem 0', marginTop: '3rem', textAlign: 'center' }}>
                <small style={{ color: 'var(--gray-light)' }}>
                    © {new Date().getFullYear()} RNA Law Chambers. All Rights Reserved.
                </small>
            </div>

            {/* Back to Top */}
            <Button
                className="position-fixed bottom-0 end-0 m-4 d-none d-md-flex"
                style={{
                    width: 56,
                    height: 56,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'var(--gold)',
                    border: 'none',
                }}
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
                <ArrowUp color="var(--primary-dark)" />
            </Button>

        </footer>
    );
};

export default Footer;
